import styled, { css } from 'styled-components';
import { rem } from 'polished';

const range = css`
  background-color: ${props => props.theme.colors.grayLight};
  height: ${rem('7px')};
`;

const ball = css`
  background-color: #fff;
  border-radius: 100%;
  border: ${rem('3px')} solid ${props => props.theme.colors.gray};
  box-sizing: border-box;
  cursor: pointer;
  height: ${rem('20px')};
  width: ${rem('20px')};
`;

const WrapperSlider = styled.div`
  font-size: 0;
  line-height: 1;
  position: relative;
  width: 100%;
`;

const StyledInputSlider = styled.input.attrs({
  type: 'range'
})`
  -webkit-appearance: none;
  border: 0;
  width: 100%;

  &:focus {
    outline: 0;
  }

  &::-webkit-slider-runnable-track {
    ${range};
  }

  &::-webkit-slider-thumb {
    ${ball};
    -webkit-appearance: none;
    margin-top: -${rem('6.5px')};
  }

  &::-moz-range-track {
    ${range};
  }

  &::-moz-range-thumb {
    ${ball};
  }
`;

const Output = styled.div`
  background-color: ${props => props.theme.colors.primary};
  height: ${rem('7px')};
  left: 0;
  position: absolute;
  top: ${rem('6px')};
  ${props =>
    props.valueSlider &&
    css`
      width: calc(${props.valueSlider}% - ${props.valueSlider / 5}px);
    `};
  z-index: 0;

  @supports (-webkit-appearance: none) {
    top: 0;
  }
`;

export { WrapperSlider, StyledInputSlider, Output };
